import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth';

import OnboardingPage from './OnboardingPage';
import AddKidRoute from './pages/AddKid/AddKidRoute';
import ChooseCardThemeCategoryPage from './pages/ChooseCardThemeCategory/ChooseCardThemeCategoryPage';
import CreateJourneyPage from './pages/CreateJourney/CreateJourneyPage';
import DownloadAppPage from './pages/DownloadApp/DownloadAppPage';
import KycRoute from './pages/kyc/KycRoute';
import OnboardingPausedPage from './pages/OnboardingPaused/OnboardingPausedPage';
import RequestPhysicalCardPage from './pages/RequestPhysicalCard/RequestPhysicalCardPage';
import TeenPreloadCardDataPage from './pages/teenPreloadCardData/TeenPreloadCardData';
import VirtualCardReadyRoute from './pages/VirtualCardReady/VirtualCardReadyRoute';

const OnboardingRoute: FuseRouteItemType = {
  path: 'onboarding',
  element: (
    <>
      <OnboardingPage />
    </>
  ),
  auth: AUTH_ROLES.parent,
  children: [
    {
      path: 'choose-card-theme-category',
      element: <ChooseCardThemeCategoryPage />,
    },
    {
      path: 'preload-card-data',
      element: <TeenPreloadCardDataPage />,
    },
    {
      ...KycRoute,
    },
    {
      ...AddKidRoute,
    },
    {
      path: 'request-physical-card',
      element: <RequestPhysicalCardPage />,
    },
    {
      ...VirtualCardReadyRoute,
    },
    {
      path: 'download-app',
      element: <DownloadAppPage />,
    },
    {
      path: 'notify-me',
      element: <DownloadAppPage />,
    },
    {
      path: 'your-info-is-in-review',
      element: <DownloadAppPage />,
    },
    {
      path: 'journey-child',
      element: <CreateJourneyPage />,
    },
    {
      path: 'paused',
      element: <OnboardingPausedPage />,
    },
  ],
};

export default OnboardingRoute;
